export default __webpack_public_path__ + "static/media/fire.82bfb395.png";